// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"6fe7b3ec9b40eea6a819","201":"ef9314076c055c8ee900","243":"b9e49f0c4364bb5ead67","682":"010d3484390bfdcb1778","688":"7eaa04119e2fd918e888","765":"85e2cb3a12e4732aa483","852":"578d5372f3ffe7f6e32d"}[chunkId] + ".bundle.js";
};